import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User, Organization } from '@/types';

interface Tokens {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  expiresIn: number;
}

interface AuthState {
  user: User | null;
  tokens: Tokens | null;
  currentOrganization: Organization | null;
  isAuthenticated: boolean;
  isLoading: boolean;

  setUser: (user: User | null) => void;
  setTokens: (tokens: Tokens | null) => void;
  setCurrentOrganization: (org: Organization | null) => void;
  setIsLoading: (loading: boolean) => void;
  login: (user: User, tokens: Tokens) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      tokens: null,
      currentOrganization: null,
      isAuthenticated: false,
      isLoading: true,

      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
        }),

      setTokens: (tokens) => set({ tokens }),

      setCurrentOrganization: (org) => set({ currentOrganization: org }),

      setIsLoading: (isLoading) => set({ isLoading }),

      login: (user, tokens) =>
        set({
          user,
          tokens,
          isAuthenticated: true,
          isLoading: false,
        }),

      logout: () =>
        set({
          user: null,
          tokens: null,
          currentOrganization: null,
          isAuthenticated: false,
          isLoading: false,
        }),
    }),
    {
      name: 'venndela-auth',
      partialize: (state) => ({
        user: state.user,
        tokens: state.tokens,
        currentOrganization: state.currentOrganization,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
